import mutations from './regionMutations';
import actions from './regionActions';
import getters from './regionGetters';

const state = {
  remRegionList: [],
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/region/regionStore.js